
export default {
    "title": "Contabilidad",
    "accounting": {
        "title": "Libro mayor",
        "pagination": "{total} Póliza | {total} Pólizas",
        "download": "Descargar Reporte"
    }
};
